// extracted by mini-css-extract-plugin
module.exports = {"section-title":"Education_section-title__2tlWz"};